import { IconPlus } from '@tabler/icons-react';
import s from './teacher-cta.module.scss';

export const TeacherCta = ({ onAdd }) => (
  <button className={s.addButton} onClick={onAdd} type="button">
    <span>Добавить занятие</span>
    <IconPlus size={20} />
  </button>
);
